import type { HealthHistoryChange } from '@ofmos/shared/health-history';
import { Link } from 'react-router';
import { clientHref } from './clientsHref';

/**
 * WHAT "+N SINCE LAST WEEK" OPENS (redesign register D10 "opens the names of those clients";
 * open question Q-FND-1, decided A: a popover listing the names as links to the client pages).
 * The content a `KpiTile`'s `changes` slot shows: one link per client whose colour moved,
 * in the history read's own order (by name).
 */
export function HealthChangesList({
  changes,
}: {
  readonly changes: readonly HealthHistoryChange[];
}) {
  return (
    <ul className="space-y-1" data-health-changes="">
      {changes.map((change) => (
        <li key={change.agencyId}>
          <Link to={clientHref(change.agencyId)} className="text-sm text-accent hover:underline">
            {change.agencyName ?? change.agencyId}
          </Link>
        </li>
      ))}
    </ul>
  );
}

/** The clients who turned to `color` since the `since` day: what the tile's "+N" counts. */
export function changesInto(
  changes: readonly HealthHistoryChange[],
  color: HealthHistoryChange['todayColor'],
): readonly HealthHistoryChange[] {
  return changes.filter((change) => change.todayColor === color && change.sinceColor !== color);
}
